import LegalPageLayout from "@/components/legal/LegalPageLayout";

const Cookies = () => {
  return (
    <LegalPageLayout title="Cookie Policy" effectiveDate="April 30, 2026" version="1.2">
      <h2>1. What Are Cookies?</h2>
      <p>
        Cookies are small text files stored on your device when you visit a website. We also use
        related technologies such as local storage, session storage, and web pixels. This Policy
        explains what we use and why across the Wavlynq portal and every sibling app
        (Fryqnc, Pulsynq, MindLynq, and the v2 apps as they launch — Spiritsynq, Jadesynq,
        Deafwav, Ablelynq, Fullynq, Openlynq).
      </p>

      <h2>2. Categories We Use</h2>
      <h3>2.1 Strictly Necessary</h3>
      <p>
        Required for the Services to function. You cannot opt out of these without losing core
        functionality.
      </p>
      <ul>
        <li><strong>Auth tokens</strong> (local storage, set by Lovable Cloud / our auth provider) — keep you signed in.</li>
        <li><strong>CSRF protection cookies</strong> — protect against cross-site request forgery.</li>
        <li><strong>Session cookies</strong> — preserve your state during a visit.</li>
        <li><strong>Auth-email throttling</strong> — short-lived hashed records used by our edge functions to rate-limit abuse on signup, magic-link, and password-reset flows.</li>
      </ul>

      <h3>2.2 Functional</h3>
      <ul>
        <li><strong>Theme and preference storage</strong> — remember your light/dark mode and language.</li>
        <li><strong>Recent activity</strong> — local cache of recently viewed profiles to make discovery faster.</li>
        <li><strong>Mapbox</strong> — map tiles and place search use short-lived tokens and may set cookies on map load. Maps only render after you interact with a feature that needs them (e.g. event location).</li>
      </ul>

      <h3>2.3 Analytics and Performance</h3>
      <ul>
        <li><strong>Google Analytics 4 (Measurement ID G-R8BN7180QY)</strong> — measures page views, traffic sources, and aggregate feature usage to help us improve the Services. IP addresses are anonymized by Google. GA4 does not record direct messages, profile content, or precise location.</li>
        <li><strong>Meta Pixel (Pixel ID 812684747933922)</strong> — measures conversions from advertising and helps us optimize sign-up campaigns. The Pixel does not record direct messages, profile content, or precise location.</li>
        <li><strong>First-party analytics</strong> — anonymized events such as feature usage and crash reports.</li>
      </ul>

      <h3>2.4 What We Do Not Use</h3>
      <ul>
        <li>We do not use third-party advertising networks for behavioral retargeting.</li>
        <li>We do not engage in cross-context behavioral advertising as defined under the CCPA/CPRA.</li>
        <li>We do not sell cookie data to data brokers.</li>
      </ul>

      <h2>3. Your Choices</h2>
      <ul>
        <li><strong>Browser controls:</strong> most browsers let you block or delete cookies. Blocking strictly necessary cookies will break sign-in.</li>
        <li><strong>Do Not Track / Global Privacy Control (GPC):</strong> we honor GPC signals as a valid opt-out of "sale" or "sharing" under applicable US state laws (we do not sell or share regardless).</li>
        <li><strong>Meta Pixel opt-out:</strong> you can manage Meta ad preferences at <a href="https://www.facebook.com/adpreferences" target="_blank" rel="noopener noreferrer">facebook.com/adpreferences</a>.</li>
        <li><strong>Google Analytics opt-out:</strong> install the <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">Google Analytics Opt-out Browser Add-on</a> to prevent GA4 from collecting data about your visits.</li>
        <li><strong>EEA/UK/CH users:</strong> we obtain consent for non-essential cookies via our cookie banner. You can change your preferences anytime via the "Cookie Settings" link in the footer.</li>
      </ul>

      <h2>4. Mobile Identifiers</h2>
      <p>
        On mobile, we may use platform-provided advertising identifiers (e.g., IDFA on iOS, AAID on
        Android) only with your platform-level permission. You can reset or limit these identifiers
        in your device settings.
      </p>

      <h2>5. Changes to this Policy</h2>
      <p>
        We will post any changes here and update the Effective Date. Material changes will be
        announced in-app or by email.
      </p>

      <h2>6. Contact</h2>
      <p>
        Young's Digital Atelier LLC<br />
        702 Richland Hills Dr #760866<br />
        San Antonio, TX 78245, USA<br />
        Privacy: <a href="mailto:privacy@wavlynq.com">privacy@wavlynq.com</a>
      </p>
    </LegalPageLayout>
  );
};

export default Cookies;
